"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncCreateNewBlogModalContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var CreateNewBlogModalContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./CreateNewBlogModalContainer'
    /* webpackChunkName: "chunk-website-blog" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});

function AsyncCreateNewBlogModalContainer(props) {
  return _react.default.createElement(CreateNewBlogModalContainer, props);
}

module.exports = exports.default;